var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampTent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 60,
    viewBox: "0 0 93 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9335 19.7946L46.0861 52.7137H68.9669L51.5832 19.3485C47.4484 20.671 43.3535 21.2605 39.2983 21.2207C35.8168 21.1888 32.3672 20.6869 28.9414 19.7946H28.9335ZM43.5128 52.7137L26.6868 20.432L9.86081 52.7137H19.0147V54.9922H6.1084L26.1132 16.5999L27.0214 16.8867C31.0845 18.1853 35.1715 18.9103 39.2904 18.9581C43.4013 18.9979 47.552 18.3526 51.7505 16.9027L52.6747 16.584L72.6954 55.0002H34.3509V52.7217H43.5048L43.5128 52.7137Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4866 52.7134L26.6947 41.5916L20.9028 52.7134H32.4946H32.4866ZM27.7065 38.6041L36.247 54.9839H17.1504L26.6947 36.6602L27.7065 38.5961V38.6041Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.545 54.984H89.2831C88.1598 51.7814 89.1636 49.232 92.2786 47.3438C89.4823 47.2482 87.0444 48.6265 86.3991 51.383C85.69 47.7581 87.5463 44.659 90.0718 42.9063C87.1559 43.5675 85.2678 45.3601 84.3914 48.2919C84.1206 46.0691 83.045 44.5156 81.1569 43.6472C82.9016 46.2603 83.2442 48.8257 82.1846 51.3512C82.1607 50.3872 81.8341 49.5506 81.1967 48.8655C81.3561 50.1083 81.0932 51.2795 80.408 52.3629C80.894 50.3394 80.6709 48.8894 79.2688 46.8738C79.6671 48.3238 79.1652 49.2559 78.241 50.7855C76.6636 47.7342 77.1257 45.0255 79.6193 42.6434C77.046 43.3923 75.6438 45.2087 75.3969 48.0927C75.0861 45.7345 73.1343 43.8623 69.5572 42.4761C72.3137 45.0972 73.676 48.3238 73.6203 52.1638C72.6881 49.6861 70.5211 48.1963 67.1113 47.6864C70.0113 49.4391 71.3816 52.2195 70.545 54.984Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6533 10.5848V5H67.9318V10.5848H65.6533Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2633 19.7227H77.5157L81.1246 23.6583L77.5157 27.5939H60.124V19.7227H61.2633ZM76.5358 22.0012H62.4105V25.3154H76.5358L78.0574 23.6583L76.5358 22.0012Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9318 16.1777V20.8622H65.6533V16.1777H67.9318Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6611 46.0929V26.4546H67.9397V46.0929H65.6611Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5961 11.7238H57.4709L55.9572 13.3809L57.4789 15.038H71.6041V11.7238H71.5961ZM56.977 9.44531H73.8747V17.3166H56.475L52.874 13.3889L56.483 9.45328H56.977V9.44531Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2731 54.9839H0.666992V52.7134H22.2731V54.9839Z",
    fill: "currentColor"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0503 14.0108H64.2109V13.5566H72.0503V14.0108Z",
    fill: "currentColor"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0425 23.4352H62.2031V22.9731H70.0425V23.4352Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampTent);
export default __webpack_public_path__ + "static/media/camp-tent.849245e66c531280c9022f9409826481.svg";
export { ForwardRef as ReactComponent };